<template>
  <div>
    <vxe-grid
      ref="refTable"
      :columns="tableColumn"
      :data="tableData"
      :min-height="30"
      :edit-config="tableConfig.editConfig"
      :mouse-config="tableConfig.mouseConfig"
      :keyboard-config="tableConfig.keyboardConfig"
      :rowConfig="{
        isCurrent: false
      }"
    >
      <template #edit_name="{ row }">
        <el-input v-model="row.name" size="mini" class="flex-1" />
      </template>
      <template #edit_fu_ze_ren="{ row }">
        <el-input v-model="row.fu_ze_ren" size="mini" class="flex-1" />
      </template>
      <template #edit_spec="{ row }">
        <el-input v-model="row.spec" size="mini" class="flex-1" />
      </template>
      <template #edit_unit="{ row }">
        <el-input v-model="row.unit" size="mini" class="flex-1" />
      </template>
      <template #edit_counts="{ row }">
        <el-input v-model="row.counts" size="mini" class="flex-1" />
      </template>
      <template #edit_goods_price="{ row }">
        <el-input v-model="row.goods_price" size="mini" class="flex-1" />
      </template>
      <template #edit_goods_amount="{ row }">
        <el-input v-model="row.goods_amount" size="mini" class="flex-1" />
      </template>
      <template #edit_gong_shi="{ row }">
        <el-input v-model="row.gong_shi" size="mini" class="flex-1" />
      </template>
      <template #edit_remark="{ row }">
        <el-input v-model="row.remark" size="mini" class="flex-1" />
      </template>
    </vxe-grid>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      tableColumn: [
        {
          title: '序号',
          type: 'seq',
          width: 50
        },
        {
          title: '工艺名称',
          field: 'name',
          slots: { edit: 'edit_name' },
          editRender: { autofocus: '.el-input__inner' }
        },
        {
          title: '负责人',
          field: 'fu_ze_ren',
          slots: { edit: 'edit_fu_ze_ren' },
          editRender: { autofocus: '.el-input__inner' }
        },
        {
          title: '规格',
          field: 'spec',
          slots: { edit: 'edit_spec' },
          editRender: { autofocus: '.el-input__inner' }
        },
        {
          title: '单位',
          field: 'unit',
          slots: { edit: 'edit_unit' },
          editRender: { autofocus: '.el-input__inner' }
        },
        {
          title: '数量',
          field: 'counts',
          slots: { edit: 'edit_counts' },
          editRender: { autofocus: '.el-input__inner' }
        },
        {
          title: '单价(元)',
          field: 'goods_price',
          slots: { edit: 'edit_goods_price' },
          editRender: { autofocus: '.el-input__inner' }
        },
        {
          title: '金额(元)',
          field: 'goods_amount',
          slots: { edit: 'edit_goods_amount' },
          editRender: { autofocus: '.el-input__inner' }
        },
        {
          title: '工时',
          field: 'gong_shi',
          slots: { edit: 'edit_gong_shi' },
          editRender: { autofocus: '.el-input__inner' }
        },
        {
          title: '备注',
          field: 'remark',
          slots: { edit: 'edit_remark' },
          editRender: { autofocus: '.el-input__inner' }
        }
      ],
      tableData: []
    }
  },
  computed: {
    // 表格配置合并
    tableConfig() {
      let obj = {
        editConfig: {
          beforeEditMethod() {
            return true
          }
        },
        keyboardConfig: {
          isEdit: true
        }
      }
      let result = this.$util.deepMerge(this.$constant.tableDefaultConfig, obj)
      return result
    }
  },
  watch: {
    tableData: {
      handler(newVal, oldVal) {
        let isChange = JSON.stringify(newVal) !== JSON.stringify(oldVal)
        if (isChange) {
          this.$emit('update:data', newVal[0])
        }
      },
      deep: true
    }
  },
  mounted() {
    this.tableData = this.$util.deepCopy([this.data]) || []
  },
  methods: {}
}
</script>

<style scoped>
.table-main {
}
</style>
